import { DateTime } from "@/util";
import { getStatusText } from "../lookup/status";
import { useWelderStatus } from "../hooks";
import { Welder } from "@/api/williams/welders";

import styles from "./Dashboard.tsx.module.css";

export function WelderDetails({ welder }: { welder: Welder }) {
  const status = useWelderStatus(welder.welderId);

  const fields = [
    { label: "Welder Name", value: welder.name },
    { label: "ID Number", value: welder.badgeNumber },
    { label: "Status", value: status.data ? getStatusText(status.data.status) : "Checking" },
    { label: "Ineligible Date", value: DateTime.getLocalDate(welder.ineligibleDate) },
    { label: "Ineligible Reason", value: welder.welderNote },
    { label: "Last 4 SSN", value: welder.ssn },
    { label: "Date Added", value: DateTime.getLocalDate(welder.creationDate) },
    { label: "Shop or Field", value: welder.shopField },
    { label: "Phone Number", value: welder.phoneNumber },
    { label: "Email Address", value: welder.emailAddress },
    { label: "Contractor", value: welder.company?.companyName },
    { label: "Welding/NDE Specialist", value: welder.weldingSpecialist?.name ?? welder.weldingSpecialist?.userName },
    { label: "Region(s)", value: welder.regions.map((x) => x.name).join(", ") },
  ];

  const visibleFields = fields.filter((x) => x.value);

  return (
    <div className="d-lg-flex flex-wrap justify-content-between">
      {/* First column */}
      <ul className={styles.fieldList}>
        {visibleFields.slice(0, 7).map((field, index) => (
          <li key={index}>
            <label>{field.label}</label>
            <span>{field.value}</span>
          </li>
        ))}
      </ul>

      {/* Second column */}
      <ul className={styles.fieldList}>
        {visibleFields.slice(7, 14).map((field, index) => (
          <li key={index}>
            <label>{field.label}</label>
            <span>{field.value}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
